import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errCode } from "../lib/api";
import { useAuth, homePath } from "../lib/auth";
import { useLang } from "../lib/i18n";
import { LangToggle } from "../components/LangToggle";
import { Wordmark } from "../components/AppShell";
import { Inp } from "../components/Common";

export default function ChangePassword() {
  const { user, ready, refresh } = useAuth();
  const { t, te } = useLang();
  const nav = useNavigate();
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [err, setErr] = useState("");
  if (ready && !user) return <Navigate to="/login" replace />;

  const submit = async (e) => {
    e.preventDefault();
    if (f.new_password !== f.confirm) return setErr("pw_mismatch");
    try {
      await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success(t("saved"));
      await refresh();
      nav(homePath(user), { replace: true });
    } catch (ex) { setErr(errCode(ex)); }
  };
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  return (
    <div className="min-h-screen p-6 flex flex-col">
      <div className="flex justify-between"><Wordmark className="h-10" /><LangToggle /></div>
      <form onSubmit={submit} className="w-full max-w-sm m-auto space-y-4" data-testid="change-password-form">
        <h1 className="text-3xl font-extrabold">{t("change_pw")}</h1>
        <p className="text-sm text-slate-600">{t("change_pw_sub")}</p>
        <Inp label={t("current_pw")} type="password" testid="current-password-input" value={f.current_password} onChange={set("current_password")} required />
        <Inp label={t("new_pw")} type="password" minLength={8} testid="new-password-input" value={f.new_password} onChange={set("new_password")} required />
        <Inp label={t("confirm_pw")} type="password" minLength={8} testid="confirm-password-input" value={f.confirm} onChange={set("confirm")} required />
        {err && <p className="text-sm font-semibold text-red-700" data-testid="change-password-error">{err === "pw_mismatch" ? t("pw_mismatch") : te(err)}</p>}
        <button className="btn-primary w-full" data-testid="change-password-submit-button">{t("save")}</button>
      </form>
    </div>
  );
}
